import React, { useState } from 'react'

// redux
import { connect } from 'react-redux'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

// react toastify
import { toast } from 'react-toastify';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    SENDERS_NAME_AND_EMAIL_UPDATED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

// API
import { addFromEmailApi } from 'utlis/Apis/Notifications_API'
import { Spinner } from 'react-bootstrap'

function EditMode(props) {
    // props
    const {
        setNotificationsData,

        setEditModeVisibility,

        senderInfo,

        authState,
    } = props

    // states
    const [btnDisabled, setbtnDisabled] = useState(false)
    const [btnLoading, setbtnLoading] = useState(false)

    // initial form values
    const initialFormValues = {
        email: senderInfo?.senderEmail ?? "",
        name: senderInfo?.senderName ?? "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        email: Yup.string().email().required('This field is required'),
        name: Yup.string(),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // btn loading
            setbtnDisabled(true)
            setbtnLoading(true)

            const requiredData = {
                from_email: values.email,
                from_name: values.name,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // network request
            addFromEmailApi(headers, requiredData).then(res => {
                // btn loading
                setbtnDisabled(false)
                setbtnLoading(false)

                const resData = res.data

                // if request succesfull
                if (resData && resData.success) {
                    setNotificationsData(resData.data) // setting notifications data

                    setEditModeVisibility(false) // closing edit mode

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the success message
                    toast.success(SENDERS_NAME_AND_EMAIL_UPDATED_SUCCESSFULLY, {
                        autoClose: 2500
                    })
                }

                // if request is not succesfull
                if (resData && resData.error) {

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} addFromEmailApi `, err.message)


                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setbtnDisabled(false)
                        setbtnLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
    })



    return (
        <div className="page-border-box2 mb-3 mb-md-4 edit-senders-info">
            <div className="pbb2-inner d-flex">
                <div className="text-sec media-body pe-3">
                    {/* header */}
                    <div className="app-header-wrapper heading-sm mb-2">
                        <p className="app-heading text-capitalize mb-2">Sender’s name and email address</p>
                        <p className="app-desc st-fs-14">
                            You can set the email address that you want to send your notifications from. The address has to be on a custom domain, as email services do not allow using their addresses to send emails by third-party services. Also, you can specify the name that appears next to the email address and helps customers identify you. It can be your company name or any other name of your liking.
                        </p>
                    </div>

                    {/* form */}
                    <div className="form col-12 col-lg-5">
                        <form
                            onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            {/* form field */}
                            <AppFormikInput
                                formik={formik} // formik object
                                stFormClass={"form-sm"} // class name for main wrapper
                                labelName={"Email"} // label name
                                isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"Email"} // placeholder for the input
                                formikFieldName={"email"} // important: formik value name for the input
                            />

                            {/* form field */}
                            <AppFormikInput
                                formik={formik} // formik object
                                stFormClass={"form-sm"} // class name for main wrapper
                                labelName={"Name"} // label name
                                // isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"Name"} // placeholder for the input
                                formikFieldName={"name"} // important: formik value name for the input
                            />

                            <div className="btns d-flex">
                                <button type="submit" className={`st-btn st-btn-primary st-btn-sm me-2 ${btnDisabled ? "disabled" : ""}`}>
                                    {
                                        btnLoading ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            "Save"
                                        )
                                    }
                                </button>
                                <button className="st-btn st-btn-link st-btn-sm no-min-width" onClick={ev => {
                                    ev.preventDefault()

                                    setEditModeVisibility(false) // enabling edit mode
                                }}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditMode)